import fetch from '../fetch'

const update = (id, data) => {
    return fetch.post('peer/review/update/' + id, data)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    update
}